import { CurrencyPipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { FormGroup, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { AddSmartSearchPropertyMortgageSelectItem } from '@platform/smart-search/models/add-smart-search-property-mortgage-select-item.model';
import { AddSmartSearchDialogFormRemortgageBorrowMore } from '@platform/smart-search/utils/formUtils';
import { FormFieldWrapperComponent } from '@shared-lib/components/form-components/form-field-wrapper/form-field-wrapper.component';
import { InputNumberComponent, InputNumberType } from '@shared-lib/components/form-components/input-number/input-number.component';
import { InputTermComponent } from '@shared-lib/components/form-components/input-term/input-term.component';
import { SelectComponent } from '@shared-lib/components/form-components/select/select.component';
import { ValidationMessageComponent } from '@shared-lib/components/form-components/validation-message/validation-message.component';
import { IconComponent } from '@shared-lib/components/icon/icon.component';
import { LabeledValueComponent } from '@shared-lib/components/labeled-value/labeled-value.component';
import { ValueType } from '@shared-lib/enums/value-type.enum';
import { TermPipe } from '@shared-lib/pipes/term.pipe';
import { StepperComponent } from '@shared/components/stepper/stepper.component';
import { smartSearchBorrowMoreReasons } from '@shared/contants';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';

@Component({
  selector: 'cp-add-smart-search-remortgage-borrow-more',
  imports: [
    StepperComponent,
    ReactiveFormsModule,
    FormFieldWrapperComponent,
    InputTermComponent,
    InputNumberModule,
    InputNumberComponent,
    InputSwitchModule,
    ButtonModule,
    IconComponent,
    LabeledValueComponent,
    SelectComponent,
    TermPipe,
    ValidationMessageComponent,
    CurrencyPipe,
    NgIf,
  ],
  templateUrl: './add-smart-search-remortgage-borrow-more.component.html',
  styleUrls: ['../add-smart-search-dialog-step.component.scss', './add-smart-search-remortgage-borrow-more.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddSmartSearchRemortgageBorrowMoreComponent implements OnInit {
  @Input({ required: true }) formGroupName: string;
  @Input({ required: true }) currentPropertyMortgageData: AddSmartSearchPropertyMortgageSelectItem;
  @Input() isBackButtonVisible = true;
  @Output() nextClicked = new EventEmitter();
  @Output() backClicked = new EventEmitter();

  private readonly rootFormGroup = inject(FormGroupDirective);

  protected stepFormGroup: FormGroup<AddSmartSearchDialogFormRemortgageBorrowMore>;
  protected readonly smartSearchBorrowMoreReasons = smartSearchBorrowMoreReasons;
  protected readonly InputNumberType = InputNumberType;
  protected readonly ValueType = ValueType;

  ngOnInit(): void {
    this.stepFormGroup = this.rootFormGroup.control.get(this.formGroupName) as FormGroup<AddSmartSearchDialogFormRemortgageBorrowMore>;

    this.stepFormGroup.patchValue({
      termInMonths: this.currentPropertyMortgageData?.mortgageTermRemaining,
    });
  }

  emitNextClicked(): void {
    if (this.stepFormGroup.valid) {
      this.nextClicked.emit();
    }
  }

  emitBackClicked(): void {
    this.backClicked.emit();
  }
}
